
import React from "react"
import Skeleton from "react-loading-skeleton";

const ProfileLoader = (props: any) =>

(
    <>
        <div className="top_sec full wf-section">
            <div className="top_content profile">
                <a className="top_back w-inline-block">
                    <Skeleton
                        circle
                        height="100%"
                        width={20}
                        containerClassName="top_back w-inline-block-skeleton"

                    />
                </a>
                <div className="full_prof_info">
                    <div className="user_basic_info">
                        <h2 className="user_name"><Skeleton height={13} width={200} containerClassName="user_name-skeleton" /></h2>
                    </div>
                    <div className="user_add_info">
                        <div className="user_place_txt"><Skeleton height={13} width={150} containerClassName="user_place_txt-skeleton" /></div>
                    </div>
                </div>
            </div>

        </div>
        <div className="content_sec full wf-section">
            <div className="content_block">
                <Skeleton
                    style={{ lineHeight: "nomral" }}
                    className="profile_pict_group"
                />
            </div>
        </div>

        <div className="nav_sec wf-section">
            <div className="content_block footer">
                <Skeleton
                    height={50}
                    width="95%"
                    className="w-button"
                />
            </div>
        </div>

    </>


)

export default ProfileLoader
